import React from "react";

const W = 460, H = 160, PL = 34, PR = 8, PT = 8, PB = 22;

export default function MiniBarChart({ labels, values, color }) {
  const max = Math.max(1, ...values);
  const n = Math.max(1, values.length);
  const slot = (W - PL - PR) / n;
  const bw = Math.max(2, slot * 0.7);
  const y = (v) => PT + (H - PT - PB) * (1 - v / max);
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((t) => Math.round(max * t));
  const step = n > 12 ? 2 : 1;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto">
      {ticks.map((t, i) => (
        <g key={i}>
          <line x1={PL} x2={W - PR} y1={y(t)} y2={y(t)} stroke="#eef0f3" />
          <text x={PL - 4} y={y(t) + 3} fontSize="8" textAnchor="end" fill="#94a3b8">{t}</text>
        </g>
      ))}
      {values.map((v, i) => {
        const cx = PL + slot * i + slot / 2;
        return (
          <g key={i}>
            <rect x={cx - bw / 2} y={y(v)} width={bw} height={H - PB - y(v)} fill={color}>
              <title>{`${labels[i]}: ${v}`}</title>
            </rect>
            {i % step === 0 && <text x={cx} y={H - 6} fontSize="7.5" textAnchor="middle" fill="#94a3b8">{labels[i]}</text>}
          </g>
        );
      })}
    </svg>
  );
}
